.featuredMenu {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(80px, 90px);
  gap: 4px !important;
  margin-bottom: 10px;
  overflow-y: hidden;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.featuredMenu .featuredItem {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: var(--cxy-color-white);
  text-align: center;
}

.featuredMenu .featuredItem .featuredIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--cxy-color-midnight-blue-600);
  border-radius: 3px;
  color: var(--cxy-color-green-300);
  height: 50px;
  width: 50px;
  font-size: 32px;
  margin-bottom: 4px;
}

.featuredMenu .featuredItem span {
  font-size: var(--cxy-fontSize-xs);
  line-height: 1.2;
  word-break: break-word;
  hyphens: auto;
}
